// Lib
import { createStructuredSelector } from 'reselect';
import { get } from 'lodash/fp';

// Selectors
import { currentBoardEditorsSelector } from './boardEditorPanelSelector';
import { createShallowSelector } from '../../../../../../utils/milanoteReselect/milanoteReselect';
import { getIsCurrentUserEmailVerified } from '../../../../../../user/currentUserSelector';

const currentBoardEditorUserIdsSelector = createShallowSelector(currentBoardEditorsSelector, (currentBoardEditors) =>
    currentBoardEditors.map(get('userId')),
);

export const boardEditorAddSectionSelector = createStructuredSelector({
    filterUserIds: currentBoardEditorUserIdsSelector,
    isCurrentUserEmailVerified: getIsCurrentUserEmailVerified,
});
